import React, { Component } from 'react';
import { connect } from 'react-redux';

import Toolbar from './Toolbar';
import Layers from '../components/Layers';

import CanvasContainer from '../components/CanvasContainer';
import {Button} from "reactstrap";
import ContainerDimensions from "react-container-dimensions";
// import CanvasFooter from '../components/CanvasFooter';
import {setPhase, closeTour, showCopyrightModal} from "../actions";
import Tour from "reactour";

class Canvas extends Component {

  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
    this.renderCheckoutButton = this.renderCheckoutButton.bind(this);
  }

  handleBack() {
    this.props.setPhase(2);
  }

  renderCheckoutButton() {
    if (this.props.products.totalAmount === 0 || (this.props.objects.present.collision || []).length !== 0) {
      return (
        <button className="btn btn-success btn-lg" data-tip="数量を選択してください" data-type="warning" data-place="bottom">
          {this.props.system.checkoutLabel}
        </button>
      );
    }

    return (
      <button className="btn btn-success" onClick={this.props.showCopyrightModal} disabled={this.props.meishi.phase < 3}>
        {this.props.system.checkoutLabel}
      </button>
    );
  }

  render() {
    //const currentSurface = this.props.objects.present.currentSurface;

    return (
      <div className="t-container-canvas">
        <div className="t-content-right-toolbar">
          <div className="actions">
            <Button onClick={this.handleBack}>前へ: テキスト入力</Button>
            {this.renderCheckoutButton()}
          </div>
          <div>自由にレイアウトを調整してください</div>
        </div>
        <Toolbar />
        <Layers />
        <ContainerDimensions>
          {({width, height}) => {
            return (
              <CanvasContainer
                parentWidth={width}
                parentHeight={height}
              />
            );
          }}
        </ContainerDimensions>

        {/*<CanvasFooter/>*/}

        <Tour
          steps={
            [
              {
                selector: '.t-canvas-container-inside',
                content: 'ここではレイアウトを自由に編集できます',
              },
              {
                selector: '.t-container-sidebar-tabs',
                content: '別のテキストやロゴを追加することが出来ます',
              }
            ]
          }
          isOpen={this.props.meishi.tour[5]}
          onRequestClose={() => { this.props.closeTour(5) }}
          showNumber={false}
        />
      </div>
    );
  }
}

export default connect(f => f, {setPhase, closeTour, showCopyrightModal})(Canvas);




// WEBPACK FOOTER //
// ./src/containers/Canvas.js